import { useEffect, useState } from "react";
import { toast } from "sonner";
import { useLang } from "../i18n/LangContext";
import { api, extractError } from "../api/client";
import { Button } from "./ui/button";
import { Card, CardContent } from "./ui/card";
import { Field } from "./Shared";
import { Scale, Loader2 } from "lucide-react";

export function LegalSettings() {
  const { t } = useLang();
  const [form, setForm] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => { api.get("/public/legal").then(({ data }) => setForm(data.data)).catch(() => {}); }, []);

  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.put("/admin/legal", {
        entity_name: form.entity_name, contact_email: form.contact_email,
        city: form.city, country: form.country, whatsapp: form.whatsapp || null,
      });
      setForm(data.data);
      toast.success(t("legal.saved"));
    } catch (err) { toast.error(extractError(err).message); }
    finally { setBusy(false); }
  };

  if (!form) return null;
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  return (
    <Card data-testid="legal-settings" className="bg-[#10121B] border-white/5">
      <CardContent className="p-5">
        <form onSubmit={save} className="space-y-4">
          <div>
            <h2 className="text-base md:text-lg font-semibold text-white inline-flex items-center gap-2">
              <Scale className="h-4 w-4 text-[#10B981]" /> {t("legal.settingsTitle")}
            </h2>
            <p className="text-xs text-slate-400 mt-1">{t("legal.settingsHint")}</p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
            <Field label={t("legal.entityName")} testId="legal-entity" value={form.entity_name || ""} onChange={set("entity_name")} />
            <Field label={t("legal.contactEmail")} testId="legal-email" type="email" value={form.contact_email || ""} onChange={set("contact_email")} />
            <Field label={t("legal.city")} testId="legal-city" value={form.city || ""} onChange={set("city")} />
            <Field label={t("legal.country")} testId="legal-country" value={form.country || ""} onChange={set("country")} />
            <Field label={t("legal.whatsapp")} testId="legal-whatsapp" value={form.whatsapp || ""} onChange={set("whatsapp")} />
          </div>
          <div className="flex justify-end">
            <Button data-testid="legal-save-btn" type="submit" disabled={busy} className="bg-[#10B981] hover:bg-emerald-500 text-white font-semibold h-10">
              {busy ? <><Loader2 className="h-4 w-4 mr-1 animate-spin" /> {t("common.loading")}</> : t("common.save")}
            </Button>
          </div>
        </form>
      </CardContent>
    </Card>
  );
}
